export default "__VITE_ASSET__BHslfRxd__"